<template>
    <div>
        <div class="row">
            <div class="col">
                <card-title-component :title="$t('guestlist.searchSection.title')"></card-title-component>
                <div class="card-content">
                </div>
            </div>
        </div>
        <div class="row filter-row">
            <div class="col-lg-6">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter"
                                      :placeholder="$t('guestlist.searchSection.searchInputPlaceholder')"
                                      class="o-form"/>
                        <b-input-group-append>
                            <b-btn :disabled="!filter"
                                   class="o-button clear-button"
                                   @click="filter = ''">
                                {{$t('guestlist.searchSection.clearButton')}}
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <card-title-component :title="$t('guestlist.resultSection.title')"></card-title-component>
                <div class="card-content">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <b-table id="contacts-table"
                         stacked="lg"
                         hover
                         small
                         fixed
                         :items="localContacts"
                         :per-page="perPage"
                         :current-page="currentPage"
                         :total-rows="totalRows"
                         :fields="computedFields"
                         :filter="filter"
                         @filtered="onFiltered">
                    <template slot="HEAD_firstname" slot-scope="" class="o-thead">

                    </template>
                    <template slot="actions" slot-scope="row">
                        <a href="javascript:void(0)" v-if="row.item.onGuestlist" @click.stop="removeFromGuestlist(row.item)">
                            {{$t('guestlist.resultSection.table.removeFromAction')}}
                        </a>
                        {{row.item.on_guestlist}}
                    </template>
                </b-table>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <b-pagination align="center"
                              size="sm"
                              :total-rows="totalRows"
                              v-model="currentPage"
                              :per-page="perPage">
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import {
        CONTACTS_ACTION_GET_CONTACTS,
        CONTACTS_ACTION_UPDATE_CONTACT,
        CONTACTS_GETTER_GUESTLIST,
        CONTACTS_MUTATION_SINGLE_ENTRY,
        CONTACTS_NAMESPACE
    } from '../../store/modules/contacts-types'
    import CardTitleComponent from '../ui/card/CardTitleComponent'
    import i18n from '../../assets/i18n/lang'

    export default {
        name: 'Guestlist',
        metaInfo () { return { title: i18n.t('guestlist.meta') } },
        components: {'card-title-component': CardTitleComponent},
        data () {
            return {
                currentPage: 1,
                perPage: 50,
                filter: '',
                totalRows: 0
            }
        },
        computed: {
            computedFields: function () {
                let fields = [
                    {key: 'firstname', label: i18n.t('guestlist.resultSection.table.firstnameCol'), sortable: true},
                    {key: 'name', label: i18n.t('guestlist.resultSection.table.lastnameCol'), sortable: true},
                    {key: 'phone', label: i18n.t('guestlist.resultSection.table.phoneCol'), sortable: false, 'class': 'text-center'},
                    {key: 'actions', label: ''}
                ]
                return fields
            },
            ...mapGetters(CONTACTS_NAMESPACE, {
                contacts: CONTACTS_GETTER_GUESTLIST
            }),
            localContacts: {
                get () { return this.contacts },
                set (value) { this.updateContacts({contacts: value}) }
            }
        },
        methods: {
            ...mapMutations(CONTACTS_NAMESPACE, {
                updateContacts: CONTACTS_MUTATION_SINGLE_ENTRY
            }),
            ...mapActions(CONTACTS_NAMESPACE, {
                loadContacts: CONTACTS_ACTION_GET_CONTACTS,
                updateContact: CONTACTS_ACTION_UPDATE_CONTACT
            }),
            onFiltered (filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            removeFromGuestlist (item) {
                this.updateContact({
                    id: item.id,
                    onGuestlist: false
                })
            }
        },
        created () {
            this.loadContacts()
                .then(() => { this.totalRows = this.localContacts.length })
                .catch((error) => { console.log(error) })
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/custom/vars';

    .clear-button {
        background-color: $omyfu-yellow;
    }

</style>



// WEBPACK FOOTER //
// src/components/funeral/GuestlistComponent.vue